import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { LocationEntity } from 'src/app/shared-module/shared/entities/location/location';

export const LOCATIONS_QUERY = gql`
query LocationsQuery
{
  locations: getLocations(filter:{}){
    id
    name
    label
  }
}
`;

export interface LocationsQueryResponse {
  loading: boolean;
  locations: LocationEntity[];

}

export const TASK_ASSIGNMENT_LIST_UNASSIGNED_QUERY = gql`
query TasksQuery(
  $pageNumber: Int,
  $pageSize: Int,
  $sortProperty: String,
  $sortDirection: String,
  $states: [TaskState],
  $text: String,
  $fromDateTime: String,
  $toDateTime: String,
  $toCompletedDateTime: String,
  $fromCompletedDateTime: String,
  $locationIds: [UUID],
  $depotIds: [UUID],
  $types: [String],
  $assignmentTypes: [String]
)
{
  tasks: getTasksPaged(
    taskFilter: { 
      states: $states,
      handlingType: PICKUP,
      text: $text,
      toDateTime: $toDateTime,
      fromDateTime: $fromDateTime,
      toCompletedDateTime: $toCompletedDateTime,
      fromCompletedDateTime: $fromCompletedDateTime,
      locationIds: $locationIds,
      depotIds: $depotIds,
      assignmentTypes: $assignmentTypes,
      types: $types,
      sortRequest: { 
        sortProperties: [$sortProperty],
        sortDirection: $sortDirection 
      },
      pagination: { 
        number: $pageNumber,
        size: $pageSize,
        sortProperty: $sortProperty,
        sortDirection: $sortDirection
      },
  }){
    totalPages
    totalElements
    number
    size
    content{
      id
      type
      title
      description
      color
      number
      noteCount
      fileCount
      taskType {
        color
      }
      state
      commands(commandInputs: [
        { name: "updateDefaultTaskCommand" },
        { name: "deleteDefaultTaskCommand" }
      ])
      dueDateTimePeriod{
        dateTime
        fromDateTime
        modifier
        toDateTime
        precision
      }
      assignmentSuggestion{
        assigneeId
        assignmentType
        dueDateTimePeriod{
          dateTime
          fromDateTime
          modifier
          toDateTime
          precision
        }
        name
        typeLabel
      }
      order {
        id
        number
        note
        customer{
          type
          companyName
          companyNameExtension
          firstName
          lastName
        }
        fileCount
        commentCount
        location {
          id
          name
          label
        }
      }
      depot{
        name
        label
      }
      linkedContacts: linkedEntities(entityType: "Contact") {
        linkId
        linkType
        linkLabel
        perspective
        role
        linkedEntity {
          ... on Contact {
            id
            type
            number
            companyName
            companyNameExtension
            firstName
            lastName
          }
        }
      }
      location {
        id
        name
        label
      }
    }
  }
}
`;

export interface TasksQueryResponse {
  tasks: Page<Task>;
  loading: boolean;
}
